import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isFormPath } from "@anton/shared";
import { trackEvent } from "../lib/track";

// Невидимый компонент: пишет события активности в backend.
// — APP_OPEN: один раз за сессию.
// — SECTION_VIEW: при каждой смене раздела.
// — FORM_START: первый ввод на странице-анкете (даже если заявку не отправили).
export function Analytics() {
  const location = useLocation();
  const appOpened = useRef(false);

  // APP_OPEN — единожды
  useEffect(() => {
    if (appOpened.current) return;
    appOpened.current = true;
    trackEvent("APP_OPEN");
  }, []);

  // SECTION_VIEW — на каждый путь
  useEffect(() => {
    trackEvent("SECTION_VIEW", location.pathname);
  }, [location.pathname]);

  // FORM_START — первое взаимодействие с полем на странице-анкете
  useEffect(() => {
    if (!isFormPath(location.pathname)) return;
    const path = location.pathname;
    let fired = false;

    const handler = () => {
      if (fired) return;
      fired = true;
      trackEvent("FORM_START", path);
      cleanup();
    };
    const cleanup = () => {
      document.removeEventListener("focusin", handler, true);
      document.removeEventListener("input", handler, true);
      document.removeEventListener("change", handler, true);
    };

    document.addEventListener("focusin", handler, true);
    document.addEventListener("input", handler, true);
    document.addEventListener("change", handler, true);
    return cleanup;
  }, [location.pathname]);

  return null;
}
